import {type ComponentPropsWithoutRef, type ReactNode, forwardRef} from "react"
import styles from "./Input.module.css"

interface InputProps extends ComponentPropsWithoutRef<"input"> {
    leftText?: string
    rightText?: string
    disabled?: boolean
    onSolidClick?: () => void
    onGradientClick?: () => void
    gradientTitle?: string
    children?: ReactNode
}

const Input = forwardRef<HTMLInputElement, InputProps>(
    (
        {
            leftText,
            rightText,
            disabled,
            onSolidClick,
            onGradientClick,
            gradientTitle,
            children,
            className,
            ...props
        },
        ref
    ) => {
        return (
            <div
                className={`${styles["input-wrapper"]} ${
                    disabled ? styles.disabled : ""
                } ${className}`}
            >
                <div className={styles["input-block"]}>
                    {leftText && (
                        <span className={styles["input-left-text"]}>
                            {leftText}
                        </span>
                    )}

                    <input
                        {...props}
                        ref={ref}
                        className={styles["input-text"]}
                    />
                </div>

                {rightText && (
                    <span className={styles["input-right-text"]}>
                        {rightText}
                    </span>
                )}
            </div>
        )
    }
)

Input.displayName = "Input"

export default Input
